import React, { Component } from "react";
import styles from './ResetForm.styles'
import messages from './ResetForm.messages';
import {FormGroup, FormControl, ControlLabel, Button} from 'react-bootstrap';

type Props = {
  onRequestSendPasswordResetEmail: () => void;
  handleShowLogin: () => void;
}

type State = {
  email: string;
}

export default class LoginForm extends Component {

  props: Props;

  state: State = {
    email: '',
  }

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
  }

  handleEmailChange = event => {
    this.setState({ email: event.target.value })
  }

  handleSend = event => {
    event.preventDefault();
    this.sendPromise = Promise.resolve(this.sendEmail());
  }

  async sendEmail() {
    await this.props.onRequestSendPasswordResetEmail(this.state.email);
    this.props.handleShowLogin();
  }

  render() {
    return (
      <form onSubmit={this.handleSend}>
        <FormGroup className="sign-inup">
          <FormControl
            style={styles.input}
            type="text"
            name={messages.email}
            placeholder={messages.email}
            onChange={this.handleEmailChange}/>
        </FormGroup>
        <button
          type='submit'
          onClick={this.handleSend}
          className='full-width m-b-15 btn btn-primary jr-btn sign-inup-submit-btn'>
          {messages.send}
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/reset-form/ResetForm.js